module.exports = __webpack_public_path__ + "img/activity-icon-2.928d537f.png";